// extracted by mini-css-extract-plugin
module.exports = {"root":"School_root__2Rm1Y","state":"School_state__3ZEkX","campus":"School_campus__zHhDf","title":"School_title__1hzj1"};